import React, { useState } from 'react'
import { exportToSheets, importFromSheets } from '../utils/sheetsSync'

function AdminVietos() {
  const [busena, setBusena] = useState(null)
  const [kraunasi, setKraunasi] = useState(false)

  async function handleExport() {
    setKraunasi(true)
    setBusena(null)
    try {
      const r = await exportToSheets()
      setBusena({
        tipas: 'ok',
        zinute: `Sėkmingai: ${r.sekminga} / ${r.isViso} vietų išsiųsta į Sheets.${r.klaidu > 0 ? ` Klaidų: ${r.klaidu}.` : ''}`,
      })
    } catch (e) {
      setBusena({ tipas: 'klaida', zinute: `Eksporto klaida: ${e.message}` })
    } finally {
      setKraunasi(false)
    }
  }

  async function handleImport() {
    setKraunasi(true)
    setBusena(null)
    try {
      const r = await importFromSheets()
      setBusena({
        tipas: 'ok',
        zinute:
          r.importuota > 0
            ? `Importuota ${r.importuota} naujų vietų į Supabase. Praleista ${r.praleista} eilučių.`
            : `Nerasta eilučių su Statusas = "importuoti". Praleista ${r.praleista} eilučių.`,
      })
    } catch (e) {
      setBusena({ tipas: 'klaida', zinute: `Importo klaida: ${e.message}` })
    } finally {
      setKraunasi(false)
    }
  }

  return (
    <div style={s.puslapis}>
      <h1 style={s.antraste}>Vietų valdymas</h1>

      <div style={s.blokas}>
        <h2 style={s.poAntraste}>Supabase → Google Sheets</h2>
        <p style={s.aprasymas}>
          Eksportuoja visas esamas vietas iš duomenų bazės į Sheets.
          Jei Sheets jau turi eilučių — naujos bus pridėtos papildomai.
          Rekomenduojama prieš tai išvalyti Sheets rankiniu būdu.
        </p>
        <button style={s.mygtukasOrange} onClick={handleExport} disabled={kraunasi}>
          {kraunasi ? 'Siunčiama...' : '⬆ Eksportuoti į Sheets'}
        </button>
      </div>

      <div style={s.blokas}>
        <h2 style={s.poAntraste}>Google Sheets → Supabase</h2>
        <p style={s.aprasymas}>
          Importuoja naujas vietas iš Sheets į Supabase. Eilutė bus importuota
          tik jei stulpelyje <strong>Statusas</strong> parašyta{' '}
          <code>importuoti</code> ir užpildyti{' '}
          <strong>Pavadinimas, Latitude, Longitude</strong>.
        </p>
        <button style={s.mygtukasJuodas} onClick={handleImport} disabled={kraunasi}>
          {kraunasi ? 'Kraunama...' : '⬇ Importuoti iš Sheets'}
        </button>
      </div>

      {busena && (
        <div
          style={{
            ...s.zinute,
            background: busena.tipas === 'ok' ? '#EAF3DE' : '#FDE8E8',
            color: busena.tipas === 'ok' ? '#3B6D11' : '#8B1A1A',
          }}
        >
          {busena.zinute}
        </div>
      )}

      <p style={s.pastaba}>
        Šis puslapis pasiekiamas per <code>/?admin</code>
      </p>
    </div>
  )
}

const s = {
  puslapis: {
    maxWidth: 430,
    margin: '0 auto',
    padding: '32px 16px',
    fontFamily: 'Syne, sans-serif',
    color: '#2C2416',
  },
  antraste: {
    fontFamily: 'Lora, serif',
    fontSize: 26,
    fontWeight: 500,
    marginBottom: 32,
    color: '#2C2416',
  },
  blokas: {
    background: '#fff',
    border: '0.5px solid #DDD5C0',
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
  },
  poAntraste: {
    fontFamily: 'Lora, serif',
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 8,
  },
  aprasymas: {
    fontSize: 13,
    color: '#5C4A2A',
    lineHeight: 1.5,
    marginBottom: 16,
  },
  mygtukasOrange: {
    background: '#D4691E',
    color: '#fff',
    border: 'none',
    borderRadius: 12,
    padding: '12px 20px',
    width: '100%',
    fontFamily: 'Syne, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
  },
  mygtukasJuodas: {
    background: '#2C2416',
    color: '#F5F0E8',
    border: 'none',
    borderRadius: 12,
    padding: '12px 20px',
    width: '100%',
    fontFamily: 'Syne, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
  },
  zinute: {
    marginTop: 16,
    padding: '14px 16px',
    borderRadius: 12,
    fontSize: 14,
    lineHeight: 1.5,
  },
  pastaba: {
    marginTop: 40,
    fontSize: 12,
    color: '#8A7E6A',
    textAlign: 'center',
  },
}

export default AdminVietos
